((w) => {
    w.PubSub.subscribe('externaltracking.webshop.search', (_, searchText) => {        
        if (searchText?.length == 0) { return; }       
        
        const viewSearchResultsEvent = {
            'event': 'search',
            'search_term': searchText
        };       

        w.dataLayer.push(viewSearchResultsEvent);
    });
})(window);